import styled from '@emotion/styled'

export const TextWrapper = styled.p`
  margin-bottom: 20px;
`

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 520px;
`

export const ButtonWrapper = styled.div`
  margin-bottom: 20px;
  text-align: center;
`
